<template>
  <div id="source-manage">
    <!-- 左边树结构 -->
    <div class="left_tree_box drag-left-layout">
      <el-radio-group v-model="treeType" size="small" class="ml-5 tree-tabs-wrapper">
        <el-radio-button label="WEB" ></el-radio-button>
        <el-radio-button label="APP"></el-radio-button>
      </el-radio-group>
      <div class="ml-4 mr-4 mt-1">
        <el-input
          v-model="searchText"
          class="self-filter-input"
          size="small"
          placeholder="搜索"
          @keyup.enter.native="filterTree"
        >
          <i slot="suffix" @click="filterTree">
            <svg-icon icon-class="input_search"></svg-icon>
          </i>
        </el-input>
      </div>

      <span class="vertical-bar fnM ml-5">资源结构</span>
      <el-tree
        ref="resourceTree"
        class="self-tree data_tree"
        node-key="id"
        :props="defaultProps"
        :data="treeData"
        :highlight-current="true"
        :filter-node-method="filterNode"
        :default-expanded-keys="defaultShowNodes"
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
      >
        <span
          slot-scope="{ node }"
          :title="node.label"
          class="self-custom-tree"
        >
          <span :class="node.isCurrent ? '' : node.data.resourceType === 0 ? 'text-blue-3377' : ''">
            <span v-html="handleFilter(node.label)"></span>
          </span>
          <el-dropdown
            trigger="hover"
            @command="
              com => {
                treeCommand(com, node.data);
              }
            "
          >
            <i class="el-icon-more"></i>
            <el-dropdown-menu slot="dropdown" :visible-arrow="false" class="resource_popover">
              <el-dropdown-item command="add" class="green_hover">
                <span>{{ $t('public.addTo') }}{{ $t('dataPermission.source') }}</span>
              </el-dropdown-item>
              <el-dropdown-item v-if="node.data.resourceType !== 1" command="edit">
                <span>{{ $t('public.edit') }}</span>
              </el-dropdown-item>
              <el-dropdown-item
                v-if="node.data.resourceType !== 1"
                command="delete"
                class="delete_hover"
              >
                <span>{{ $t('public.delete') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </el-tree>
      <!-- 添加/编辑 -->
      <el-dialog
        v-dialogDrag
        :title="dialogAdd ? '添加资源' : '编辑资源'"
        class="scource_dialog"
        :visible.sync="sourceVisible"
      >
        <el-form ref="resourceForm" size="small" :model="formData" :rules="formRules">
          <el-form-item label="资源名称" prop="resourceName">
            <el-input v-model="formData.resourceName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="资源路径" prop="resourcePath">
            <el-input v-model="formData.resourcePath" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="资源编码" prop="resourceCode">
            <el-input v-model="formData.resourceCode" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="排序(升序)" prop="sort">
            <el-input v-model="formData.sort" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="remark">
            <el-input
              v-model="formData.remark"
              placeholder="请输入描述信息，限50字以内"
              type="textarea"
              :rows="4"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button plain size="small" @click="sourceVisible = false">
            {{ $t('public.cancel') }}
          </el-button>
          <el-button type="primary" size="small" @click="handleSubmit">
            {{ $t('public.confirm') }}
          </el-button>
        </div>
      </el-dialog>
      <!-- 删除 -->
      <el-dialog v-dialogDrag :visible.sync="deleteVisible" class="delete_dialog">
        <div class="warning_title fnM fn16">
          <svg-icon class="before_icon" icon-class="dialog_warning"></svg-icon>
          确认要删除资源结构“{{ formData.resourceName }}”吗？
        </div>
        <p v-if="formData.children && formData.children.length > 0" class="delete_tips">
          该资源结构内含有子项，不能被删除！
        </p>
        <p v-else class="delete_tips">如果该结构有关联的资源，删除后将无法恢复。</p>

        <div slot="footer" class="dialog-footer">
          <div v-if="formData.children && formData.children.length > 0">
            <el-button type="primary" size="small" @click="deleteVisible = false">
              知道了
            </el-button>
          </div>

          <div v-else>
            <el-button plain @click="deleteVisible = false">{{ $t('public.cancel') }}</el-button>
            <el-button type="danger" @click="deleteTreeItem">{{ $t('public.confirm') }}</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <!--  右边内容 -->
    <div class="right_content">
      <div class="top_info_box">
        <span class="vertical-bar fn18 fnM">{{ detailInfo.resourceName }}</span>
        <div class="detail_box">
          <div class="detail_resource_path">
            资源路径：
            <div v-if="!detailInfo.resourcePath" class="resource_path_setting">
              暂未配置资源路径，请前往：系统管理/菜单管理页面中进行配置。
              <el-link type="success" @click="gotoMenuList">立即配置</el-link>
            </div>
            <span v-else>{{ detailInfo.resourcePath }}</span>
          </div>
          <div class="detail_sort">排序：{{ detailInfo.sort }}</div>
        </div>
        <div class="detail_box">
          <div class="detail_resource_path">
            描述：
            <span v-if="detailInfo.remark">{{ detailInfo.remark }}</span>
            <span v-else class="empty_description">暂无</span>
          </div>
        </div>
      </div>
      <div class="split_bar"></div>
      <div class="table_content">
        <div style="position: sticky; top: 0">
          <div class="search_box">
            <span class="vertical-bar fn18 fnM" style="line-height: 32px">资源列表</span>
            <el-button
              size="small"
              class="float-right"
              type="primary"
              @click="sourceInit(detailInfo)"
            >
              初始化资源
            </el-button>
            <el-button
              v-if="tableData.length != 0"
              size="small"
              class="float-right"
              style="width: 80px; margin-right: 10px; margin-left: 0"
              type="primary"
              @click="saveSource"
            >
              保存
            </el-button>
            <el-input
              v-model="tableSearch"
              size="small"
              placeholder="请输入关键字"
              class="float-right"
              style="width: 303px; margin-right: 8px"
              clearable
              @clear="getDetailList"
              @keyup.enter.native="getDetailList"
            >
              <i slot="suffix" style="padding-right: 8px" @click="getDetailList">
                <svg-icon icon-class="input_search"></svg-icon>
              </i>
            </el-input>
            <!-- <el-button size="small" class="float-right" style="margin-right: 8px">
                多语言设置
              </el-button> -->
          </div>

          <div class="small_table">
            <customTable order height="500px" :table-data="tableData" :show-pagination="false">
              <el-table-column prop="resourceElementLabel" label="资源名称">
                <template slot-scope="scope">
                  {{ $t(scope.row.resourceElementLabel) }}
                </template>
              </el-table-column>
              <el-table-column label="自定义名称">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.resourceElementExtendLabel"
                    class="self-filter-input"
                    size="small"
                    placeholder="请输入"
                  ></el-input>
                  <!-- <span v-if="!editState">{{ scope.row.resourceElementExtendLabel }}</span> -->
                </template>
              </el-table-column>
              <el-table-column prop="resourceElementCode" label="资源标识" />
              <el-table-column prop="type" label="类型" width="100">
                <template slot-scope="scope">
                  {{ $t(`common.${TypeObject[scope.row.resourceElementType]}`) }}
                </template>
              </el-table-column>
            </customTable>
          </div>
        </div>
        <el-dialog
          :visible.sync="resourceSettingDialog"
          class="resource_setting_dialog"
          width="440px"
        >
          <template slot="title">
            <div class="resource_setting_dialog_title">
              <svg-icon icon-class="warning" class="resource_setting_icon"></svg-icon>
              此处暂未配置资源路径
            </div>
          </template>
          <div class="resource_setting_dialog_content">
            配置资源路径请前往：
            <span class="resource_path_setting">系统管理/菜单管理</span>
            页面进行处理，如果您没有相关权限，请联系系统管理员解决。
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button plain size="small" @click="resourceSettingDialog = false">取消</el-button>
            <el-button type="primary" size="small" @click="gotoMenuList">立即配置</el-button>
          </span>
        </el-dialog>

        <!-- 初始化资源弹窗 -->
        <el-dialog
          v-dialogDrag
          title="初始化数据源"
          :visible.sync="initResourceVisible"
          class="scource_dialog init_dialog"
        >
          <div class="overflow-hidden">
            <div v-show="isMicroPath" style="height: 400px; width: 100%">
              <div id="mircapp_per"></div>
            </div>
            <div v-show="!isMicroPath" class="small_table">
              <customTable order height="400px" :table-data="initData" :show-pagination="false">
                <el-table-column label="资源名称" prop="resourceElementLabel">
                  <template slot-scope="scope">
                    {{ $t(scope.row.resourceElementLabel) }}
                  </template>
                </el-table-column>
                <el-table-column label="授权标识" prop="resourceElementCode"></el-table-column>
                <el-table-column label="授权策略" prop="permissionPolicy"></el-table-column>
                <el-table-column label="推送状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.pushState === 0" class="circle_before grey_before">
                      未推送
                    </span>
                    <span v-if="scope.row.pushState === 1" class="circle_before">已推送</span>
                    <span v-if="scope.row.pushState === 2" class="circle_before red_before">
                      推送失败
                    </span>
                  </template>
                </el-table-column>
              </customTable>
            </div>
            <div v-if="!isMicroPath" slot="footer" class="text-right mt-5">
              <el-button plain size="small" class="plain_button mr-5" @click="initResourceVisible = false">
                取消
              </el-button>
              <el-button v-if="treeType === 'APP'" size="small" plain class="mr-5" @click="jsonDialog = true">JSON</el-button>
              <el-button type="primary" size="small" @click="pushAndRefresh">推送并刷新</el-button>
            </div>
            <el-button
              v-if="isMicroPath"
              plain
              size="small"
              style="width: 80px; float: right; margin-right: 10px"
              class="plain_button"
              @click="initResourceVisible = false"
            >
              取消
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <el-dialog title="资源列表" :visible="jsonDialog">
      <json-editor v-model="jsonData"></json-editor>
      <template #footer>
        <div class="text-right">
          <el-button plain class="mr-5" @click="jsonDialog = false">取消</el-button>
          <el-button type="primary" @click="handleJson('increment')">增量更新</el-button>
          <el-button type="primary" @click="handleJson('full')">全部更新</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import resourceApi from "@/api/data-permission/dataPermission";
import JsonEditor from "@/components/common/JsonEditor";
import { mapGetters } from "vuex";
import { checkIsMircApp } from "@/utils/mircApp";
import { commonFilterNode } from "@/utils";
import { Message } from "element-ui";
import { loadMicroApp } from "qiankun";
export default {
  name: "ResourceMange",
  components: { JsonEditor },
  props: {},
  data() {
    return {
      searchText: "",
      filterText: "",
      formData: {},
      formRules: {
        resourceName: [{ required: true, message: "资源名称不能为空", trigger: "blur" }],
        resourcePath: [{ required: true, message: "资源路径不能为空", trigger: "blur" }],
        resourceCode: [{ required: true, message: "资源编码不能为空", trigger: "blur" }]
      },
      dialogAdd: true,
      sourceVisible: false,
      deleteVisible: false,
      treeData: [],
      defaultShowNodes: [],
      currentNode: null,
      defaultProps: {
        children: "children",
        label: "resourceName"
      },
      detailInfo: {},
      tableSearch: "",
      tableData: [],
      initData: [],
      initResourceVisible: false,
      resourceSettingDialog: false,
      TypeObject: {
        1: "column",
        2: "button",
        3: "tab",
        4: "input",
        5: "select",
        6: "dataPicker",
        7: "timePicker",
        8: "switch",
        9: "checkbox",
        10: "radio",
        11: "textarea",
        12: "tag"
      },
      currentPermissionList: [],
      microApp: null,
      isMicroPath: false,
      treeType: "WEB",
      jsonDialog: false,
      jsonData: ""
    };
  },
  computed: {
    ...mapGetters(["mircAppDic"])
  },
  watch: {
    sourceVisible(val) {
      if (!val) {
        this.formData = {};
        this.$refs.resourceForm.clearValidate();
      }
    },
    deleteVisible(val) {
      if (!val) {
        // this.formData = {};
      }
    },
    initResourceVisible(val) {
      if (val && this.isMicroPath) {
        this.$nextTick(() => {
          this.componentDidMount();
        });
      }
    },
    treeType() {
      this.centerSearchText = "";
      this.currentNode = null;
      this.initData = [];
      this.detailInfo = {};
      this.getTreeList();
    }
  },
  created() {
    this.getTreeList();
  },
  beforeDestroy() {
    this.componentWillUnmount();
  },
  methods: {
    componentDidMount() {
      if (this.microApp && this.microApp.update) {
        this.microApp.update({ url: this.currentNode.resourcePath, id: this.currentNode.id });
      } else {
        this.$nextTick(() => {
          this.microApp = loadMicroApp({
            name: "mircapp_per",
            entry: `${this.mircAppDic["scim-edm-web"].url}/index_per.html`,
            container: "#mircapp_per",
            props: {
              url: this.currentNode.resourcePath,
              id: this.currentNode.id
            }
          });
        });
      }
    },

    componentWillUnmount() {
      this.microApp && this.microApp.unmount();
    },
    //  获取树资源
    getTreeList() {
      resourceApi.getResourceTree({ parseToTree: true, clientType: this.treeType }).then(res => {
        this.treeData = res.data;
        this.$nextTick(() => {
          if (!this.currentNode) {
            const [node] = this.treeData;
            this.currentNode = node;
            this.defaultShowNodes.push(node.id);
          }

          this.$refs.resourceTree && this.$refs.resourceTree.setCurrentKey(this.currentNode.id);

          this.getResourceDetail();
          this.getDetailList();
        });
      });
    },
    // 手动高亮筛选文本
    handleFilter(str) {
      if (!this.filterText || !str) {
        return str;
      }
      const index = str.indexOf(this.filterText);
      const beforeStr = str.substr(0, index);
      const afterStr = str.substr(index + this.filterText?.length);
      if (index > -1) {
        return `${beforeStr}<span style="color:#00B259;">${this.filterText}</span>${afterStr}`;
      } else {
        return str;
      }
    },
    // 筛选树
    filterTree() {
      this.filterText = this.searchText;
      this.$refs.resourceTree.filter(this.searchText);
    },
    // 节点筛选
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultShowNodes.push(data.id);
      }
    },
    handleNodeCollapse(data) {
      this.defaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.defaultShowNodes.length = i;
        }
      });
    },
    // 节点点击
    handleNodeClick(node) {
      this.currentNode = node;
      this.isMicroPath = checkIsMircApp(node.resourcePath);
      this.getResourceDetail();
      this.getDetailList();
    },
    // 树元素点击
    treeCommand(com, data) {
      this.formData = {};
      if (com === "add") {
        this.formData.parentId = data.id;
        this.dialogAdd = true;
        this.sourceVisible = true;
      }
      if (com === "edit") {
        // eslint-disable-next-line no-unused-vars
        const { children, ...obj } = data;
        this.formData = obj;
        console.log(this.formData);
        this.dialogAdd = false;
        this.sourceVisible = true;
      }
      if (com === "delete") {
        this.formData = data;
        this.deleteVisible = true;
      }
    },
    // 表单提交
    handleSubmit() {
      this.$refs.resourceForm.validate(valid => {
        if (valid) {
          if (this.dialogAdd) {
            resourceApi.addResource({ ...this.formData, clientType: this.treeType }).then(res => {
              console.log(res);
              Message.success("添加成功");
              this.sourceVisible = false;
              this.getTreeList();
            });
          } else {
            resourceApi.editResource(this.formData).then(res => {
              console.log(res);
              Message.success("修改成功");
              this.sourceVisible = false;
              this.getTreeList();
            });
          }
        }
      });
    },
    // 处理json
    async handleJson(type) {
      if (!this.jsonData) {
        return;
      }

      const resources = JSON.parse(this.jsonData);

      if (!Array.isArray(resources)) {
        this.$message.error("请上传数组格式的资源列表！");
        return;
      }
      // 全量替换
      if (type === "full") {
        this.initData = resources.map(item => ({ ...item, pushState: 0 }));
        this.jsonDialog = false;
        return;
      }

      // 获取增量的资源列表
      const incrementList = resources.filter(item => !this.tableData.find(subItem => item.resourceElementCode === subItem.resourceElementCode)).map(item => ({ ...item, pushState: 0 }));

      // 获取增量的所有资源列表
      this.initData = [...this.tableData.map(item => ({ resourceElementLabel: item.resourceElementLabel, resourceElementCode: item.resourceElementCode, resourceElementType: item.resourceElementType, pushState: 1 })), ...incrementList];
      this.jsonDialog = false;
    },
    // 删除
    deleteTreeItem() {
      resourceApi
        .deleteResourceById(this.formData.id)
        .then(res => {
          Message.success("删除成功");
          this.formData = {};
          if (this.currentNode.id === this.formData.id) {
            this.currentNode = null;
          }
          this.deleteVisible = false;
          this.getTreeList();
        })
        .catch(() => {
          this.formData = {};
        });
    },
    // 获取节点详情
    getResourceDetail() {
      // this.currentNode.id  "1461278252017610752"
      resourceApi.getResourceDetailById(this.currentNode.id).then(res => {
        console.log(res);
        if (res.data) {
          this.detailInfo = res.data;
        } else {
          this.detailInfo = {};
        }
      });
    },
    // 获取资源列表
    getDetailList() {
      resourceApi.getResourceList(this.currentNode.id, { search: this.tableSearch }).then(res => {
        this.tableData = res.data;
        // 未使用微服务
        if (this.currentNode.resourcePath && !this.isMicroPath) {
          this.initData = [...this.tableData.map(item => ({ resourceElementLabel: item.resourceElementLabel, resourceElementCode: item.resourceElementCode, resourceElementType: item.resourceElementType, pushState: 1 }))];
          //    拼接链接获取本地组件地址
          try {
            const assembly = () => require(`@/views/standard${this.currentNode.resourcePath}`);
            this.currentPermissionList = assembly().default.methods.permissionList();
            this.initData = this.currentPermissionList.map(item => {
              const obj = { ...item, pushState: 0 }; //  0 未推送  1已推送

              if (this.tableData.some(tl => tl.resourceElementCode === item.resourceElementCode)) {
                obj.pushState = 1;
              }
              return obj;
            });
          } catch (error) {
            throw new Error(error);
          }
        } else {
          this.initData = [];
        }
      });
    },
    // 初始化资源推送
    pushAndRefresh() {
      resourceApi.batchPush(this.initData, this.currentNode.id).then(res => {
        Message.success("推送成功");
        this.getDetailList();
        this.initResourceVisible = false;
      }, () => {
        this.initResourceVisible = false;
      });
    },
    sourceInit(info) {
      const { resourcePath } = info;
      if (resourcePath) {
        this.initResourceVisible = true;
        return;
      }

      this.resourceSettingDialog = true;
    },
    // 前往菜单管理
    gotoMenuList() {
      this.$router.push({ path: "/menu/menu-list-sys" });
    },
    saveSource() {
      resourceApi.saveResource(this.currentNode.id, this.tableData).then(() => {
        this.getDetailList();
        Message.success("保存成功");
      });
    }
  }
};
</script>

<style scoped lang="scss">
#source-manage {
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  .left_tree_box {
    flex: 0 224px;
    width: 224px;
    background-color: #f9f9fb;
    overflow: hidden;
    .data_tree {
      margin-top: 16px;
      overflow-y: auto;
      height: calc(100% - 96px);
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      .el-icon-more {
        transform: rotate(90deg);
      }
    }
    .data_tree::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  .resource_path_setting {
    display: inline-block;
    color: #ffa046;
  }

  .empty_description {
    color: #9ea5b2;
  }

  .right_content {
    flex: 1;
    overflow-y: auto;
    height: calc(100vh - 106px);
    .top_info_box {
      padding: 24px;
      .detail_box {
        display: flex;
        margin-top: 24px;
        line-height: 20px;
        justify-content: center;
        align-items: center;
        .detail_resource_path {
          flex: 1;
        }

        .detail_sort {
          width: 120px;
        }

        .menu_setting {
          margin-left: 40px;
        }
      }
    }

    .split_bar {
      height: 8px;
      width: 100%;
      background-color: #f9f9fb;
    }
    .table_content {
      padding: 24px;
      .search_box {
        // padding-top: 24px;
        margin-bottom: 16px;
        overflow: hidden;
      }
    }
  }
  .before_12::before {
    height: 12px;
  }
  .before_16::before {
    height: 16px;
  }
  .circle_before {
    position: relative;
    display: inline-block;
    padding-left: 10px;
  }
  .circle_before::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 8px;
    background-color: #00b259;
  }
  .grey_before::before {
    background-color: #505363;
  }
  .red_before::before {
    background-color: #e60000;
  }
  .plain_button {
    color: #505363;
    background-color: #fff;
  }
  .plain_button:hover {
    color: #00b259;
  }
  .plain_button:focus {
    color: #00b259;
  }
}
</style>

<style lang="scss">
#source-manage {
  .self-filter-input {
    margin-bottom: 20px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
    .el-input__icon {
      color: #9da5b2;
    }
    .el-input__clear {
      line-height: 32px;
    }
  }

  .el-radio-button {
    margin-top: 0px;
    .el-radio-button__inner {
      padding: 8px 10px;
      width: 88px;
      font-size: 12px;
    }
  }

  // 对话框样式重置
  .scource_dialog {
    .el-dialog {
      width: 527px;
      .el-dialog__header {
        padding: 24px 40px 8px 40px;
        .el-dialog__title {
          font-weight: bold;
        }
      }
      .el-dialog__body {
        padding: 6px 40px;
        .suffix_icon {
          width: 14px;
          height: 14px;
          position: relative;
          top: 1px;
          right: 5px;
        }
      }
      .dialog-footer {
        padding: 0px 20px 4px 20px;
        margin-top: 0;
      }
    }
  }
  .init_dialog {
    .el-dialog {
      width: 1006px;
    }
  }
  .delete_dialog {
    .el-dialog {
      width: 428px;
      .el-dialog__header {
        padding-top: 18px;
        padding-bottom: 0;
        .el-dialog__headerbtn {
          position: absolute;
          top: 24px;
          right: 20px;
        }
      }
      .el-dialog__body {
        .warning_title {
          line-height: 22px;
          .before_icon {
            width: 24px;
            height: 22px;
            margin-right: 2px;
            vertical-align: bottom;
          }
        }
        .delete_tips {
          color: #505363;
          line-height: 20px;
          font-size: 14px;
          margin-top: 16px;
          text-indent: 32px;
        }
      }
    }
  }

  .resource_setting_dialog {
    .resource_setting_dialog_title {
      font-size: 15px;
      font-weight: bold;
    }

    .resource_setting_dialog_content {
      margin-left: 25px;
      padding: 0 0 10px;
      line-height: 21px;
    }

    .resource_setting_icon {
      font-size: 20px;
      color: #ffa046;
    }
  }

  .el-button--small {
    padding: 8px 16px;
    box-shadow: none;
  }

  //   重写table样式-小型
  .small_table {
    .el-table {
      th {
        padding: 6px 0;
        height: 36px;
      }
      th:first-child {
        padding-left: 10px;
      }
      .el-input {
        margin-bottom: 0;
        .el-input__inner {
          height: 24px;
          line-height: 24px;
        }
      }
      td {
        padding: 4px 0;
        height: 32px;
      }
      td:first-child {
        padding-left: 10px;
      }
    }
    .el-pagination {
      padding: 0;
      .el-pagination__total {
        height: 24px;
        line-height: 24px;
      }
      button {
        height: 24px;
        line-height: 24px;
        min-width: 24px;
      }
      .el-pager {
        .number {
          height: 24px;
          line-height: 24px;
          min-width: 24px;
        }
      }
      .pagination-jumper {
        height: 24px;
        line-height: 24px;
        input {
          width: 24px;
          height: 24px;
          line-height: 24px;
        }
      }
      .pagination-sizes {
        height: 24px;
        line-height: 24px;
        .pagination-select {
          height: 24px;
          .el-input {
            .el-input__inner {
              height: 24px;
            }
          }
        }
      }
    }
  }
}
.resource_popover .el-dropdown-menu__item:hover {
  background-color: #f5f7fa !important;
}
.resource_popover {
  .el-dropdown-menu__item span {
    color: #505363;
  }
  .green_hover:hover {
    span {
      color: #00b259;
    }
  }
  .delete_hover:hover {
    span {
      color: #e60000;
    }
  }
}
</style>
